import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';

import DropdownWrapper from '../DropdownWrapper';

const AboutUsNavGroup = () => {
  return (
    <DropdownWrapper>
      <LinkNav to={getPageLink('page-about')} className="nav-link">
        About Us
      </LinkNav>
      <div className="dropdown-menu">
        <div className="dropdown-wrapper">
          <div className="links-title">
            <LinkNav to={getPageLink('page-about')}>About Us</LinkNav>
            <p>
              Military Benefit Association (MBA) is a non-profit association
              created to safeguard and promote the economic welfare of current
              and former service members, federal employees, and their families.
            </p>
          </div>
          <div>
            <LinkNav
              to={getPageLink('page-leadership-staff')}
              className="dropdown-item"
            >
              Leadership
            </LinkNav>
            <LinkNav
              to={getPageLink('page-articles-of-organization')}
              className="dropdown-item"
            >
              Articles of Organization
            </LinkNav>
            <LinkNav
              to={getPageLink('page-life-notes')}
              className="dropdown-item"
            >
              Life Notes
            </LinkNav>
            <LinkNav
              to={getPageLink('page-contact-us')}
              className="dropdown-item"
            >
              Contact Us
            </LinkNav>
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default AboutUsNavGroup;
